import { JSONSchema7 } from "json-schema";
import { UiSchema } from "@rjsf/utils";

import FormSchema from "../../models/schema/FormSchema";

export type EditorKind = "boolean" | "select" | "number" | "date" | "email" | "text";

export interface FieldEditor {
  kind: EditorKind;
  /** Nur für `select`: die im Formular hinterlegten Auswahlmöglichkeiten. */
  options?: string[];
}

const anyOfOptions = (property: JSONSchema7): string[] =>
  (property.anyOf ?? [])
    .map((entry) => {
      const option = entry as JSONSchema7;
      return option.title ?? (Array.isArray(option.enum) ? String(option.enum[0]) : "");
    })
    .filter((title) => title !== "");

/**
 * Leitet das passende Eingabeelement aus dem Formularschema ab, damit der Drawer
 * dieselben Feldtypen anbietet wie das öffentliche Formular.
 */
export const resolveFieldEditor = (property: string, formSchema?: FormSchema): FieldEditor => {
  const jsonSchema = formSchema?.formSchema;
  const uiSchema: UiSchema | undefined = formSchema?.uiSchema;

  const definition = (jsonSchema?.properties?.[property] as JSONSchema7) ?? undefined;
  const uiEntry = uiSchema?.[property] as Record<string, unknown> | undefined;

  if (uiEntry?.["ui:widget"] === "limitedCheckbox") return { kind: "boolean" };
  if (uiEntry?.["ui:field"] === "date") return { kind: "date" };
  if (uiEntry?.["ui:field"] === "zipCode") return { kind: "text" };

  if (!definition) return { kind: "text" };

  const options = anyOfOptions(definition);
  if (options.length > 0) return { kind: "select", options };

  if (definition.type === "boolean") return { kind: "boolean" };
  if (definition.type === "number" || definition.type === "integer") return { kind: "number" };
  if (definition.format === "email") return { kind: "email" };

  return { kind: "text" };
};
